/**
 * EmptyState Component
 */

import { replaceQueue } from '../../../../redux/actions/player';
import { getPlayerTracksFromResults } from '../../../../redux/helpers/player';
import { environment } from '../../../../relay';
import { EmptyStateFragment, EmptyStateQuery } from '../../../../relay/emptyState';
import { RelayOperationBase } from '../../../../utils/relay';
import { getLicenseParamsForRouteQuery } from '../../../../utils/router';
import './styles.scss';

import { withRouter, WithRouter } from 'found';
import { concat } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { createFragmentContainer, QueryRenderer } from 'react-relay';

import LoadingSpinner from '../../../atoms/feedback/LoadingSpinner';
// import Charts from '../../content/Charts';
import Collections from '../../content/Collections';
import FeaturedArtistList from '../../content/FeaturedArtists';
// import FrontfundrBanner from '../../content/FrontfundrBanner';
import NewsletterPromo from '../../content/NewsletterPromo';
import SearchTermsBox from '../../content/SearchTermsBox';
import StaffPicks from '../../content/StaffPicks';

interface IOwnDispatchProps {
  setPlayerQueue(tracks: IPlayerTrack[]): void;
}

interface IOwnProps {
  className?: string;
  viewer: GQL.IViewer;
  isUserLoggedIn: boolean;
}

type EmptyStateProps = IOwnProps & IOwnDispatchProps & WithRouter;

const classes = new BEM('empty-state');
const defaultList = [];

class EmptyState extends React.Component<EmptyStateProps> {
  componentDidMount() {
    const data = this.props.viewer.home_page!;

    const allTracks = concat(
      data.featured_artist_tracks || defaultList,
      data.featured_tracks || defaultList,
      ...(data.track_charts || defaultList).map(({ items }) => items || defaultList),
    );

    this.props.setPlayerQueue(getPlayerTracksFromResults(allTracks));
  }

  render() {
    const data = this.props.viewer.home_page!;
    const featuredTerms = data.featured_terms || defaultList;
    const staffPicks = data.featured_tracks || defaultList;
    const featuredCollections = data.featured_collections || defaultList;
    const featuredArtists = data.featured_artist_tracks || defaultList;
    // const charts = data.track_charts || defaultList;

    return (
      <div {...classes('', '', this.props.className)}>
        <div {...classes('content-wrapper')}>
          <StaffPicks tracks={staffPicks} />
          {/* <FrontfundrBanner /> */}
          <SearchTermsBox data={featuredTerms} {...classes('search-terms')} />
          <FeaturedArtistList data={featuredArtists} />
          <Collections data={featuredCollections} />
          <NewsletterPromo isUserLoggedIn={this.props.isUserLoggedIn} />
          {/* <Charts data={charts} itemBackgroundColor="bw3" /> */}
        </div>
      </div>
    );
  }
}

const EmptyStateRelay = createFragmentContainer(
  EmptyState,
  EmptyStateFragment,
);

const EmptyStateRenderer: React.SFC<EmptyStateProps> = ({ className, match, ...ownProps }) => {
  return (
    <QueryRenderer<RelayOperationBase<Pick<ITrackSearchQueryVariables, 'license_params'>, EmptyStateProps>>
      environment={environment}
      query={EmptyStateQuery}
      variables={{
        license_params: getLicenseParamsForRouteQuery(match),
      }}
      render={({ error, props }) => {
        if (error) {
          return <div>{error.message}</div>;
        } else if (props) {
          return <EmptyStateRelay {...props} {...ownProps} className={className} />;
        }
        return <LoadingSpinner center />;
      }}
    />
  );
};

const ConnectedEmptyState = connect<{}, IOwnDispatchProps, IOwnProps, IStoreState>(
  ({ user }) => ({
    isUserLoggedIn: user.isLoggedIn,
  }),
  (dispatch) => ({
    setPlayerQueue: (tracks) => {
      dispatch(replaceQueue({ tracks }));
    },
  }),
)(EmptyStateRenderer);

export default withRouter(ConnectedEmptyState) as React.ComponentType<Pick<IOwnProps, 'className'>>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/sections/EmptyState/index.tsx